import React, { useEffect, useState, useRef } from "react";
import AnimateHeight from "react-animate-height";

export default function ToolWrapper({
  toolConfig,
  userIsPro,
  environment,
  children,
}) {
  const [toolOpen, setToolOpen] = useState(false);
  const [canOpen, setCanOpen] = useState(false);
  const [setHeight, setHeightState] = useState("0px");

  const { tool_is_in_uat: toolIsInUat, tool_is_pro: toolIsPro } = toolConfig;

  const content = useRef(null);

  // --- ALL THE OPEN STUFF
  useEffect(() => {
    let canOpenTool = checkCanOpen();
    setCanOpen(canOpenTool);
  }, []);

  useEffect(() => {
    let canOpenTool = checkCanOpen();
    setCanOpen(canOpenTool);
  }, [environment, userIsPro]);

  function checkCanOpen() {
    let tests = [];
    if (toolIsPro && !userIsPro) {
      tests.push(false);
    }
    if (toolIsInUat && environment !== "beta") {
      tests.push(false);
    }
    return tests.includes(false) ? false : true;
  }

  function handleToggleOpen() {
    if (canOpen) {
      setToolOpen(!toolOpen);
      setHeightState(toolOpen ? "0px" : `${content?.current?.scrollHeight}px`);
    }
  }
  // --- END OF  ALL THE OPEN STUFF

  return (
    <div
      id={toolConfig.tool_id + "-tool"}
      className="grid tool-section mt-0 pb-0 pos-rel"
    >
      {!canOpen ? <div className="centered-overlay crosshatch"></div> : null}
      <div
        className={"grid cs1 ce12 mt-0  "}
        style={{
          cursor: canOpen ? "pointer" : "default",
        }}
        onClick={(event) => {
          handleToggleOpen();
        }}
      >
        <div className={"cs1 mb-0 icon m2 " + toolConfig.tool_icon}></div>
        <div className="cs2 ce11 h3 mb-0">{toolConfig.tool_name}</div>
        <div
          style={{
            cursor: canOpen ? "pointer" : "default",
          }}
          className={
            "cs12 icon m2 mb-0 mt-0  " +
            " " +
            (toolOpen === false ? " icon-arrow-right" : " icon-arrow-down")
          }
        ></div>
      </div>
      {!canOpen ? (
        <div className="cs1 ce12 p-medium mt-0">
          {toolConfig.tool_short_description}
        </div>
      ) : null}
      {/* <div
        id="accordion-content"
        ref={content}
        style={{ maxHeight: `${setHeight}` }} */}
      <AnimateHeight
        id="example-panel"
        duration={500}
        height={toolOpen ? "auto" : 0}
        className="cs1 ce12"
        easing="cubic-bezier(0, 1, 0.5, 1)"
      >
        <div id="accordion-margin" className="cs1 ce12 grid mb-8">
          {children}
        </div>
      </AnimateHeight>
    </div>
  );
}
